import { axiosClient } from "@/api/axios";

export function insert(data) {
  return axiosClient.post(`posts/add`, data);
}
